import {
  CheckCircleIcon,
  CircleAlertIcon,
  EyeIcon,
  EyeOffIcon,
  RotateCcwIcon,
  User2Icon,
} from 'lucide-react'
import { ReactNode } from 'react'

import { SmartQuestionStatus } from '@/gen/inventory/v1/control_service_pb'

export const smartQuestionStatusToIcon: Record<SmartQuestionStatus, ReactNode> = {
  [SmartQuestionStatus.UNSPECIFIED]: null,
  [SmartQuestionStatus.UNPUBLISHED]: <EyeOffIcon size={14} />,
  [SmartQuestionStatus.PUBLISHED]: <EyeIcon size={14} />,
  [SmartQuestionStatus.AWAITING_REVIEW]: <CircleAlertIcon size={14} />,
  [SmartQuestionStatus.AWAITING_RECIPIENT]: <User2Icon size={14} />,
  [SmartQuestionStatus.RESOLVED]: <CheckCircleIcon size={14} />,
  [SmartQuestionStatus.AWAITING_REOPEN]: <RotateCcwIcon size={14} />,
}
